import React from 'react';
import { Switch } from 'antd';

function EmSwitch({ onChange, checked }) {
    return <Switch checked={checked} onChange={onChange} />;
}

export { EmSwitch };
